$( document ).ready(function() {

  /** Preloader **/

  // makes sure the whole site is loaded
  jQuery(window).on('load',function() {
    // will first fade out the loading animation
    jQuery("#status").fadeOut();
    // will fade out the whole DIV that covers the website.
    jQuery("#preloader").delay(1000).fadeOut("slow");
  })

  /** Scroll to Top **/

  // Set a variable for our button element.
  const scrollToTopButton = document.getElementById('js-top');

  // Let's set up a function that shows our scroll-to-top button if we scroll beyond the height of the initial window.
  const scrollFunc = () => {
    // Get the current scroll value
    let y = window.scrollY;

    // If the scroll value is greater than the window height, let's add a class to the scroll-to-top button to show it!
    if (y > 0) {
      scrollToTopButton.className = "totop-link show";
    } else {
      scrollToTopButton.className = "totop-link hide";
    }
  };

  window.addEventListener("scroll", scrollFunc);

  const scrollToTop = () => {
    // Let's set a variable for the number of pixels we are from the top of the document.
    const c = document.documentElement.scrollTop || document.body.scrollTop;

    // If that number is greater than 0, we'll scroll back to 0, or the top of the document.
    // We'll also animate that scroll with requestAnimationFrame:
    // https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      // ScrollTo takes an x and a y coordinate.
      // Increase the '10' value to get a smoother/slower scroll!
      window.scrollTo(0, c - c / 10);
    }
  };

  // When the button is clicked, run our ScrolltoTop function above!
  scrollToTopButton.onclick = function(e) {
    e.preventDefault();
    scrollToTop();
  }

  /** Map Accordian **/

  $('.accordion').on('click', '.accordion-control', function(e){
    e.preventDefault(); //prevent default action of a button 
    $(this) //get the element the user clicked on
    .next('.accordion-panel') //select the next accordion panel
    .not(':animated') //if it is not currently animating
    .slideToggle(); //use slideToggle to show or hide it
  });

  $("body").click(function(){
    $(".modal_shadow").hide()
  });
  
  if (window.location.href.indexOf("?contact_posted=true") > -1) {
        window.location.href = "https://www.healthnutrition.co.za/pages/enquiry-submitted";
  }
  if (window.location.href.indexOf("?customer_posted=true") > -1) {
        window.location.href = "https://www.healthnutrition.co.za/pages/newsletter-subscription-success";
  }
  if (window.location.href.indexOf("?contact%5Btags%5D=newsletter&form_type=customer") > -1) {
        window.location.href = "https://www.healthnutrition.co.za/pages/already-a-subscriber";
  }
  
  $(".banner__inner-text .subtitle p:contains('OPTIMAL HEALTH')").html(function(_, html) {
    return html.replace(/(OPTIMAL HEALTH)/g, '<span class="ban_bolder">OPTIMAL HEALTH</span>');
  });
  $(".banner__inner-text .subtitle p:contains('IMAGINE...')").html(function(_, html) {
    return html.replace(/(IMAGINE...)/g, '<span class="ban_bolder">IMAGINE...</span>');
  });
  $(".banner__inner-text .subtitle p:contains('IMPROVE')").html(function(_, html) {
    return html.replace(/(IMPROVE)/g, '<span class="ban_bolder">IMPROVE</span>');
  });
  $(".banner__inner-text .subtitle p:contains('CARING')").html(function(_, html) {
    return html.replace(/(CARING)/g, '<span class="ban_bolder">CARING</span>');
  });

  /** Remove Dropdown Link **/
  $(".dropdown-link").each(function(){
    $(this).removeAttr("href");
  });
  
  /** Logo Carousel **/
  $("#rcbrand").rcbrand({
      visibleItems: 3,
      itemsToScroll: 1,
      autoPlay: {
          enable: true,
          interval: 3000,
          pauseOnHover: true
      }
  });

  /** Remove Duplicate Product **/
  $(".thumbnail__link").each(function() {
    if (this.href.indexOf('alexia-rich-special') != -1) {
       $(this).css('display', 'none');
    }
  });

  // program to display time every 3 seconds
  function showTime() {    
    $(".thumbnail__link").each(function() {
      if (this.href.indexOf('alexia-rich-special') != -1) {
         $(this).css('display', 'none');
      }
    });  
      // display the time after 3 seconds
       setTimeout(showTime, 3000);
  }  
  // calling the function
  showTime();
});